import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import './EquipoPublico.css';

const EquipoPublico = () => {
  const isLocal = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
  const apiBase = isLocal ? `http://${window.location.hostname}:3010` : `${window.location.protocol}//${window.location.hostname}`;
  const { codigo } = useParams();
  const [equipo, setEquipo] = useState(null);
  const [error, setError] = useState(null);
  const [theme, setTheme] = useState(localStorage.getItem('app-theme') || 'dark');

  const toggleTheme = () => {
    const newTheme = theme === 'dark' ? 'light' : 'dark';
    setTheme(newTheme);
    localStorage.setItem('app-theme', newTheme);
    document.body.setAttribute('data-theme', newTheme);
  };

  useEffect(() => {
    const fetchEquipo = async () => {
      if (!codigo) return;
      try {
        const resp = await fetch(`${apiBase}/api/publico/equipo/${codigo}`, { credentials: 'include' });
        if (resp.ok) {
          setEquipo(await resp.json());
        } else {
          setError('El equipo escaneado no fue encontrado o no existe en nuestras bases.');
        }
      } catch(err) {
        setError('Error contactando al servidor maestro.');
      }
    };
    fetchEquipo();
  }, [apiBase, codigo]);

  const getStatusClass = (status) => {
    const map = {
      'En servicio': 'en-servicio',
      'Sin uso': 'sin-uso',
      'En mantenimiento': 'mantenimiento',
      'En préstamo': 'prestamo',
      'Extraviado': 'extraviado',
      'Sustraído': 'sustraido',
      'Dado de baja': 'dado-de-baja'
    };
    return map[status] || 'otro';
  };

  return (
    <div className="public-asset-container">
      {/* Universal Theme Toggle */}
      <button 
        onClick={toggleTheme}
        className="theme-toggle-floating"
        style={{
          position: 'fixed',
          top: '30px',
          right: '30px',
          background: 'var(--card-bg)',
          backdropFilter: 'blur(12px)',
          border: '1px solid var(--glass-border)',
          color: theme === 'dark' ? 'var(--p-amber)' : 'var(--p-indigo)',
          padding: '10px 16px',
          borderRadius: '20px',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '8px',
          transition: 'all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
          zIndex: 1000,
          boxShadow: 'var(--shadow-lg)'
        }}
        onMouseEnter={(e) => { e.currentTarget.style.transform = 'scale(1.05)'; }}
        onMouseLeave={(e) => { e.currentTarget.style.transform = 'scale(1)'; }}
      >
        <i className={theme === 'dark' ? 'fa-solid fa-sun' : 'fa-solid fa-moon'}></i>
        <span style={{ fontSize: '12px', fontWeight: 'bold' }}>{theme === 'dark' ? 'Modo Claro' : 'Modo Oscuro'}</span>
      </button>

      {error ? (
        <div className="public-asset-card" style={{ textAlign: 'center' }}>
          <i className="fa-solid fa-circle-exclamation" style={{ fontSize: '50px', color: 'var(--p-rose)', marginBottom: '20px' }}></i>
          <h3 style={{ color: 'var(--p-navy)' }}>{error}</h3>
          <p style={{ color: 'var(--p-slate)' }}>Por favor, escanee una etiqueta oficial válida.</p>
        </div>
      ) : !equipo ? (
        <div className="public-asset-card" style={{ textAlign: 'center' }}>
          <div className="spinner" style={{ marginBottom: '20px' }}></div>
          <h3 style={{ color: 'var(--p-navy)' }}>Leyendo Etiqueta QR...</h3>
          <p style={{ color: 'var(--p-slate)' }}>Validando autenticidad en servidor municipal</p>
        </div>
      ) : (
        <>
          <div className="certification-watermark">CERTIFICADO</div>
          
          <div className="public-asset-card">
            <div className="public-header">
              <img src="/logo_pitrufquen.png" alt="Logo Municipalidad" className="municipal-logo" />
              <h1>Ficha Técnica de Activo</h1>
            </div>

            <div className="asset-id-display">
              <span className="asset-id-label">Nro. Inventario Oficial</span>
              <span className="asset-id-value">{equipo.codigo}</span>
            </div>

            <div className="asset-details-list">
              <div className="asset-detail-item">
                <span className="detail-label"><i className="fa-solid fa-microchip"></i> Modelo</span>
                <span className="detail-value">{equipo.modelo}</span>
              </div>

              <div className="asset-detail-item">
                <span className="detail-label"><i className="fa-solid fa-tag"></i> Clasificación</span>
                <span className="detail-value">{equipo.categoria}</span>
              </div>

              <div className="asset-detail-item">
                <span className="detail-label"><i className="fa-solid fa-shield-halved"></i> Estado Físico</span>
                <span className={`status-badge-premium ${getStatusClass(equipo.estado)}`}>
                  {equipo.estado}
                </span>
              </div>

              <div className="asset-detail-item">
                <span className="detail-label"><i className="fa-solid fa-user-tie"></i> Custodio Actual</span>
                <span className="detail-value" style={{ color: equipo.custodio_nombre ? 'var(--p-navy)' : 'var(--p-amber)' }}>
                  {equipo.custodio_nombre || 'En Bodega Municipal'}
                </span>
              </div>
            </div>

            <div className="asset-notes-panel">
              <div className="notes-header">
                <i className="fa-solid fa-comment-medical"></i> Notas Técnicas
              </div>
              <p className="notes-content">
                {equipo.detalle || 'No existen reportes ni observaciones pendientes para este dispositivo en el sistema maestro.'}
              </p>
            </div>
          </div>

          <div className="public-footer">
            &copy; 2026 MUNICIPALIDAD DE PITRUFQUÉN — UDT
          </div>
        </>
      )}
    </div>
  );
};

export default EquipoPublico;
